import * as React from "react";
import { Contractor } from "../../interfaces/Contractors";
import {Button} from "react-bootstrap";
import "./index.scss";

interface IState {
    open: boolean;
    selectedContractor: Contractor;
}

interface IProps {
    contractors: Contractor[];
    add: () => void;
    select: (contractor: Contractor) => void;
}

export default class extends React.Component<IProps, IState> {

    constructor(props){
        super(props);
        this.state = {
            open: false,
            selectedContractor: null
        }
    }

    select( e ){
        if (this.state.selectedContractor != null){
            this.props.select(this.state.selectedContractor);
        }
        e.preventDefault();
        e.stopPropagation();
        return false;
    }


    render(){
        return (
            <div id="custom-selector">
                <div className="custom-selector-input-box d-flex align-items-center justify-content-between" onClick={() => this.setState({open: !this.state.open})}>
                    <p>{this.state.selectedContractor ? this.state.selectedContractor.name : "Select contractor"}</p>
                    <Button onClick={(e) => this.select(e)}>Select</Button>
                </div>
                {
                    this.state.open ? 
                        <div className="custom-selector-dropdown">
                        {
                            this.props.contractors.map((contractor, index) => (
                                <div className="custom-selector-dropdown-item" key={index} onClick={() => this.setState({selectedContractor: contractor, open: false})}>
                                    <p>{contractor.name}</p>
                                </div>
                            )) 
                        }    
                        <div className="custom-selector-dropdown-item" onClick={() => this.props.add()}>
                            <p className="d-flex align-items-center">
                                <i className="fas fa-plus" />
                                <span className="ml-3">add</span>
                            </p>
                        </div>
                    </div> : null
                }                          
            </div>
        )
    }
}